import Vue from 'vue'
import Vuex from 'vuex'
import { IAlertState } from './modules/alert'
import { IForm } from './modules/form'

Vue.use(Vuex)

export interface IRootState {
  alert: IAlertState
  form: IForm
}

export default new Vuex.Store<IRootState>({})
